import React, { useEffect, useState } from "react";
import api from "../../api/api";
import CloseIcon from '@mui/icons-material/Close';
import { getPracticeId } from '../../config/practice';

const EditDevicesModal = ({ isOpen, selectedcolumn, onClose, setOpenToast,
  setToastMessage,
  fetchdata,
  setToastSeverity, apiLoading,}) => {
  const deviceTypes = [
    { label: "BPP", value: "bpp" },
    { label: "CGM", value: "cgm" },
    { label: "CPAP", value: "cpap" },
    { label: "WLM", value: "wlm" },
    { label: "EKG", value: "ekg" },
  ];
  const practiseid = getPracticeId();
const isAssignedFromRPM = selectedcolumn?.rpm && selectedcolumn.rpm.length > 0;
console.log(isAssignedFromRPM,selectedcolumn,'isassigned')
  const [formData, setFormData] = useState({
    serialNo: "",
    type: "",
    details: "",
    deviceno: "",
    status: false,
  });
const[loading,setLoading]=useState(false)
useEffect(() => {
  if (selectedcolumn) {
    const assigned = selectedcolumn?.rpm && selectedcolumn.rpm.length > 0;

    setFormData({
      serialNo: selectedcolumn?.deviceserialnumber || "",
      type: selectedcolumn?.devicetype || "",
      details: selectedcolumn?.devicedetails || "",
      deviceno: selectedcolumn?.deviceno || "",
      status: assigned, // 🔥 status from rpm array
    });
  }
}, [selectedcolumn]);


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const submitEdit = async () => {
    setLoading(true)
   
    try {
      // const response = await api.put(
      //   `/v1/${practiseid}/rpm_devices/patient/${selectedcolumn?.patientid}/update_device`,
      //   {
      //     id: selectedcolumn?.id,
      //     deviceno: selectedcolumn.deviceno,
      //     devicesno: formData.serialNo,
      //     devicetype: formData.type,
      //     devicedtls: formData.details,
      //     status: formData.status ? 1 : 0,
      //     created_by: selectedcolumn?.created_by,
      //   }
      // );
            let response={}
      if(selectedcolumn?.patientid){
 response = await api.put(
        `/v1/${practiseid}/rpm_devices/patient/${selectedcolumn?.patientid}/update_device`,
        {
          id: selectedcolumn?.id,
          deviceno: formData.deviceno,
          devicesno: formData.serialNo,
          devicetype: formData.type,
          devicedtls: formData.details,
          status: formData.status ? 1 : 0,
          created_by: selectedcolumn?.created_by,
        }
      );
      }else{
 response = await api.put(
        `/v1/${practiseid}/rpm_devices/update_device/${selectedcolumn.id}`,
        {
      
          devicedtls: formData.details,
          deviceno: formData.deviceno,
          created_by: selectedcolumn?.created_by,
        }
      );
      }
      if (response.status === 200) {
        setToastMessage(response.message || "Device added successfully.");
        setToastSeverity("success");
        setOpenToast(true);
        fetchdata();
        onClose(false); // Close the modal after successful submission
      } else {
        setToastMessage(response.message || "Failed to add device.");
        setToastSeverity("info");
        setOpenToast(true);
      }
     
    } catch (error) {
      console.error("Error updating device:", error);
    }finally{
      setLoading(false)
    }
  };

  return (
    isOpen && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white rounded-lg shadow-lg w-[600px]  relative">
          <div className="flex justify-between items-center border-b  bg-[#E179544A] p-3">
            <h2 className="text-lg font-inter">Edit Devices</h2>
            <button className="text-gray-500 hover:text-gray-800 " onClick={() => onClose(false)}>
            <CloseIcon style={{width:"22px"}}/>
            </button>
          </div>

          <form className="grid font-font1 grid-cols-2 gap-4 mt-4 text-start px-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Serial No</label>
              <input
                type="text"
                name="serialNo"
                value={formData.serialNo}
                onChange={handleChange}
                disabled
                className="mt-1 w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Type</label>
              <select
                name="type"
                value={formData.type}
                onChange={handleChange}
                disabled
                className="mt-1 w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300 cursor-not-allowed"
              >
                <option value="">Select type</option>
                {deviceTypes.map((type) => (
                  <option key={type.value} value={type.value}>
                    {type.label}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Details</label>
              <input
                type="text"
                name="details"
                value={formData.details}
                onChange={handleChange}
                className="mt-1 w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Device No(Email)</label>
              <input
                type="text"
                name="deviceno"
                value={formData.deviceno}                
                onChange={handleChange}
                className="mt-1 w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
              />
            </div>

            <div className="col-span-2 text-start">
              <label className="block text-sm font-medium text-gray-700">Status</label>
              <div className="flex items-center mt-1 px-3">
            <span className="mr-4">Unassigned</span>
                <label className="relative inline-flex items-center cursor-pointer mt-2">
               <input
  type="checkbox"
  name="status"
  checked={formData.status}
  onChange={(e) => {
    // allow only UNASSIGN
    if(!isAssignedFromRPM){
        setToastMessage("Please assign this device to a patient before updating status.");
    setToastSeverity("info");
    setOpenToast(true);
    return
    }
    if (isAssignedFromRPM && formData.status === true) {
      handleChange(e);
    }
  }}
  // disabled={!isAssignedFromRPM} 
  className="sr-only peer"
/>

                 <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-500 rounded-full peer dark:bg-gray-700 peer-checked:bg-blue-500 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600" />
                </label>
               
                     <span className="ml-4">Assigned</span>
              </div>
            </div>
          </form>

          <div className="flex justify-end mt-6 space-x-2 p-3">
            <button
              className="px-4 py-2 border-[1.5px] border-[#ccc] rounded-md "
              onClick={() => onClose(false)}
            >
              Close
            </button>
            <button
              className={`px-4 py-2 text-white rounded-md bg-[#E17954] ${
                loading ? "bg-[#E17954] cursor-not-allowed" : "bg-[#E17954] "
              }`}
              onClick={submitEdit}
              disabled={loading}
            >
              {loading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default EditDevicesModal;
